import { useEffect, useState } from 'react';

// Services
import billingService from '../../services/billingService';

//Hooks
import useUser from '../user/useUser';

const initialfilters = {
    pageSize: 10,
    pageNumber: 1,
}

const useVouchers = ( filters = initialfilters ) => {
    const { branch } = useUser()
    const [searchResult, setSearchResult] = useState({
        vouchers: [],
        totalPage: 0
    })
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getVouchersFromServer = () => {
            const req = {
                ...filters,
                customerDocNum: filters.customerDocNum?.toString(),
                sellerCode: filters.sellerCode?.toString(),
                branchCode : branch.code
            }

            if(filters.paymentMethods)
                req.paymentMethods = Array.isArray(filters.paymentMethods)
                    ? filters.paymentMethods
                    : [filters.paymentMethods]

            setLoading(true);
            billingService
                .SearchVouchers( req )
                .then(res => setSearchResult({
                    vouchers: res.values,
                    totalPage: res.totalPage,
                    totalResults: res.totalResults
                }))
                .finally(() => setLoading(false));
        }
        if (!loading && branch.code && filters && filters.channel) 
            getVouchersFromServer();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, branch.code])

    return {
        ...searchResult,
        loading
    }
}

export default useVouchers;